import { each, every, filter, includes, map, some } from "lodash";
import React from "react";
import CollapsibleList from "../PropertyGroupPage/CollapsibleList";

interface Props {
  traps: {
    [key: string]: ITrap;
  };
  properties: IProperty[];
  selectProperty: (item: ICollapsibleListItem) => void;

}

const Properties = ({
  traps,
  properties,
  selectProperty,
}: Props) => {
  const items = map(properties, (property): ICollapsibleListItem => {
    // extract possible statuses from traps
    const zones = map(property.trapping_zones, (zone) => zone.id);

    const due: boolean[] = [];
    const done: boolean[] = [];
    const filteredTraps = filter(traps, (trap) =>
      includes(zones, trap.trapping_zone_id)
    );
    each(filteredTraps, (trap) => {
      due.push(trap.status.due);
      done.push(trap.status.done);
    });
    const status = {
      due: some(due, (i) => i === true),
      done: every(done, (i) => i === true),
    };
    return {
      id: property.id,
      title: property.identifier,
      data: property,
      description: property.name,
      status,
    };
  });
  return (
    <CollapsibleList
      title="Orchard"
      subTitle="Status"
      collapse={false}
      items={items}
      onItemClick={selectProperty}
    />
  );
};

export default Properties;